import { Injectable, EventEmitter } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs/Rx';
import { Response } from '@angular/http';
// Interfaces
import {
	IService,
	IApplicationModel, IContact, IStep, IStepModel, IStepsModel
} from '../../interfaces';
// classes
import { ApplicationCreateForm, ApplicationForm, ApplicationModel, ApplicationStatus } from '../../classes';
// Enums
import { ApplicationStatusEnum } from '../../enums';
// Services

import { LogService} from '../../services/log/log.service';
import { ServerService} from '../../services/server/server.service';
import { HelperService} from '../../services/helper/helper.service';
import { UserService} from '../../services/user/user.service';
import { StorageService} from '../../services/storage/storage.service';
import { error } from 'selenium-webdriver';




@Injectable()
export class StepService implements IService {
	// implements local variables
	_step = new BehaviorSubject<IStepModel>(undefined);
	_steps = new BehaviorSubject<IStepsModel>(undefined);
	_completed = new BehaviorSubject<boolean>(false);
	OnSaveValidate$ = new EventEmitter<boolean>(true);
	OnStepRefreshed$ = new EventEmitter<boolean>(true);

	_data: {
		step: IStepModel,
		steps: IStepsModel,
		completed: boolean,
		applicationId: string
	};

	// implements IService
	name = 'StepService';
	test(name, value) {
		console.log('testing', name, value);
	}

	constructor(
		private _logSrv: LogService,
		private _userSrv: UserService,
		private _serverSrv: ServerService,
		private _helperSrv: HelperService,
		private _storageSrv: StorageService
	) { }

	get STEP() {
		return this._step;
	}

	set Step(value: IStepModel) {
		this.DATA.step = value;
		this._step.next(value);
	}

	get STEPS() {

		return this._steps;
	}

	set Steps(value: IStepsModel) {
		this.DATA.steps = value;

		'setting steps'.logWithObject(this.name, value);
		if (this._helperSrv.isUndefined(value)) {
			this.Completed = false;
		} else {
			this.Completed = value.Steps.every(s => s.Step.IsCompleted);
		}
		this._steps.next(value);
	}

	get COMPLETED() {

		return this._completed;
	}

	set Completed(value: boolean) {
		this.DATA.completed = value;
		this._completed.next(value);
	}

	get DATA() {
		if (this._data === undefined) {
			this._data = {
				step: undefined,
				steps: undefined,
				completed: false,
				applicationId: undefined
			};
			return this._data;
		}
		return this._data;
	}



	getSteps(applicationid: string): Promise<IStepsModel> {
		const key = this._storageSrv.GetKey(this._storageSrv.KEY_STEPS);
		const endPoint = `${this._helperSrv.ApiLocation}step/applicationid/${applicationid}/key/${key}`;
		return this._serverSrv.GetWithAuth(this._userSrv.Data.contact.AcepId, endPoint)
			.map(response => {
				try {
					const body = response.json();
					const data = <IStepsModel>body.Data;
					this.Steps = data;
					this.DATA.applicationId = applicationid;
					this._logSrv.Debug(this.name, ['getSteps', response, body, this.DATA.steps]);
					return data;
				} catch (err) {
					this._logSrv.Error(this.name, ['getSteps', err]);
					throw new Error(response.statusText);
				}
			})
			.toPromise();
	}

	getStep(stepid: string): Promise<IStepModel> {
		const key = this._storageSrv.GetKey(this._storageSrv.KEY_STEP);
		const endPoint = `${this._helperSrv.ApiLocation}step/stepid/${stepid}/key/${key}`;
		return this._serverSrv.GetWithAuth(this._userSrv.Data.contact.AcepId, endPoint)
			.map(response => {
				try {
					const body = response.json();
					const data = <IStepModel>body.Data;
					this.Step = data;
					this._logSrv.Debug(this.name, ['getStep', response, body, this.DATA.step]);
					return data;
				} catch (err) {
					this._logSrv.Error(this.name, ['getStep', err]);
					throw new Error(response.statusText);
				}
			})
			.toPromise();
	}

	refreshSteps(): Promise<IStepsModel> {
		this._storageSrv.RemoveKey(this._storageSrv.KEY_STEP);
		this._storageSrv.RemoveKey(this._storageSrv.KEY_STEPS);
		return this.getSteps(this.DATA.applicationId);
	}

	refreshStep(): Promise<IStepModel> {
		this._storageSrv.RemoveKey(this._storageSrv.KEY_STEP);
		this._storageSrv.RemoveKey(this._storageSrv.KEY_STEPS);
		return this.getStep(this.DATA.step.StepId);
	}

	updateStep(): Promise<IStepModel> {
		const url = this.DATA.step.Links.find(l => l.Name === 'PutStep').Href;


		this._storageSrv.RemoveKey(this._storageSrv.KEY_STEPS);
		this._storageSrv.RemoveKey(this._storageSrv.KEY_STEP);
		return this._serverSrv.PutWithAuthWithURL(
			this._userSrv.Data.contact.AcepId, url, this.DATA.step.Step)
			.map(response => {
				try {
					if (response.status === 200) {

						const body = response.json();
						const data = body.Data;
						this.Step = data;
						return data;
					} else {
						this._logSrv.Error(this.name, ['updateStep response', response]);
						throw new Error(`Unable to update step ${this.DATA.step.Step.Name}`);
					}
				} catch (err) {
					this._logSrv.Error(this.name, ['updateStep error', err]);
					throw new Error(`Unable to update step ${this.DATA.step.Step.Name}`);
				}
			})
			.toPromise();
	}
}



// WEBPACK FOOTER //
// C:/AZURE/ACEP/Acep.Crm.WebPortal/CrmWebPortalGlobal/Membership/AngularApps/PACED/PACEDAngular/src/app/share/services/step/step.service.ts